// @ts-check
/**
 * @file useDocumentTitle.js
 * @location src/hooks/useDocumentTitle.js
 * @role document.title 에 미정독 카운트 접두 — 「(N) 온점」.
 *   N === 0 일 때 「온점」 로 복귀. 100 이상은 「(99+) 온점」 로 절단.
 */
import { useEffect } from 'react';

const BASE = '온점';

export function useDocumentTitle(count) {
  useEffect(() => {
    const safe = Math.max(0, Math.floor(count ?? 0));
    if (safe === 0) {
      document.title = BASE;
    } else if (safe > 99) {
      document.title = `(99+) ${BASE}`;
    } else {
      document.title = `(${safe}) ${BASE}`;
    }
  }, [count]);
}
